<template>
    <div class="applications-filters">
        <div class="applications-filters__filter" v-for="filter of filters" :key="filter.name">
            <form-select-group
                :label="$tc(`applicationsFilters.${filter.name}`)"
                :options="filtersSelectOptions[filter.name]"
                @input="applyFilter()"
                v-model="filtersCriteria[filter.name]"
            >
            </form-select-group>
        </div>
    </div>
</template>

<script>
import {store, FormSelectGroup} from "atom";
const {createNamespacedHelpers} = store;
const {mapActions, mapState} = createNamespacedHelpers("arcman");
export default {
    name: "applications-filters",
    props: {
        applications: {type: Array, required: true},
        adaptiveFilters: {type: Boolean, default: true},
    },
    components: {
        FormSelectGroup,
    },
    computed: {
        ...mapState(["filters"]),
        filtersSelectOptions() {
            let filtersSelectOptionsObj = {};
            for (let [key, value] of Object.entries(this.filters)) {
                let filterList = [];
                if (value.list && value.list.length) {
                    filterList = value.list
                        .map(element => {
                            if (typeof element === "object") {
                                return element;
                            } else {
                                return {text: element, value: element};
                            }
                        })
                        .filter(obj => obj?.text?.trim().length);
                    filterList.sort((a, b) => (b?.text?.toUpperCase() > a?.text?.toUpperCase() ? -1 : 1));
                    filterList.unshift({text: this.$tc("words.any"), value: null});
                }
                filtersSelectOptionsObj[key] = filterList;
            }
            return filtersSelectOptionsObj;
        },
        hasApplicationsAndFilters() {
            return this.applications?.length && this.filters && this.filtersResetFlag ? true : false;
        },
    },
    watch: {
        applications: {
            handler(newValue, oldValue) {
                this.updateApplicationsFilters({applications: newValue, filtersCriteria: this.filtersCriteria});
            },
            immediate: true,
        },
        filters: {
            handler(newValue, oldValue) {
                if (newValue === null || typeof oldValue === "undefined") {
                    this.initFilters();
                }
                if (oldValue === null) {
                    this.filtersResetFlag = true;
                }
            },
            immediate: true,
        },
        hasApplicationsAndFilters: {
            handler(newValue, oldValue) {
                if (newValue) {
                    this.initFiltersCriteria();
                    this.updateFilters({
                        applications: this.applications,
                        filtersCriteria: this.filtersCriteria,
                    });
                    this.filtersResetFlag = false;
                }
            },
            immediate: true,
        },
    },
    data: () => {
        return {
            filtersCriteria: {},
            filtersResetFlag: false,
        };
    },
    methods: {
        ...mapActions({
            filterApplications: "SET_CRITERIA_THEN_APPLY_FILTERS",
            updateFilters: "UPDATE_FILTERS",
            initFilters: "INIT_FILTERS",
            resetFilters: "RESET_FILTERS",
        }),
        applyFilter() {
            this.filterApplications(this.filtersCriteria);
        },
        initFiltersCriteria() {
            for (let key of Object.keys(this.filters)) {
                this.$set(this.filtersCriteria, key, null);
            }
        },
        updateApplicationsFilters(payload) {
            if (this.adaptiveFilters) {
                this.updateFilters(payload);
            }
        },
    },
    beforeDestroy() {
        this.resetFilters();
    },
};
</script>

<style lang="scss" scoped>
.applications-filters::v-deep {
    @apply flex flex-col justify-start items-end;
    @screen lg {
        @apply flex flex-row;
    }

    .applications-filters__filter {
        @apply flex items-end mr-2;
        width: $filter-group-width;
    }

    .sah-form-select-group {
        @apply w-full;
    }

    .sah-form-select-group__select {
        @apply w-full;
        border-color: $border-filters-color;
    }
}
</style>
